module.exports = __webpack_public_path__ + "img/moved-to-follow-ups.a0ff1afd.svg";